import React from "react";
import ESIPage from "@/components/esi-page/ESIPage";
import { capitalize } from "lodash";

function generateMetadata(params) {
  const title = params?.slug?.[0]?.split("-").map(capitalize).join(" ");
  return {
    title: title || "Shopping With Us",
    description: `Our Terms and Conditions outline the guidelines for our site, competitions, and services. Find all the key info about your My John Lewis membership here.`,
  };
}

function Page() {
  return <ESIPage />;
}

Page.generateMetadata = generateMetadata;

export default Page;
